import { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useForm } from 'react-hook-form';
import { Box, Divider } from "@material-ui/core";

/** Import entities */
import { CxQuestionType } from "../../entity/entities";

/** Import reducer */
import { changeErrorCount } from "./PreviewReducer";

/** Import components */
import { Dropdown } from "../question/Dropdown";
import { FreeText } from "./FreeText";
import { RadioButton } from "./RadioButton";
import { SelectScore } from "./SelectScore";
import { CheckBox } from "./CheckBox";
import { Zipcode } from "./Zipcode";
import { Calendar } from "./Calendar";

const {
  SELECT_SCORE,
  FREE_TEXT,
  DROPDOWN,
  RADIO_BUTTON,
  CHECKBOX,
  ZIPCODE,
  CALENDAR,
} = CxQuestionType;

export const Questions = (props: { pageIndex: number; cxQuestions: any }) => {
  const { pageIndex, cxQuestions } = props;

  const dispatch = useDispatch();

  const {
    control,
    register,
    formState: { errors },
  } = useForm({
    criteriaMode: 'all',
    mode: 'onBlur',
  });

  const errorCount = Object.keys(errors).length;
  useEffect(() => {
    dispatch(
      changeErrorCount({ errorCount })
    );
  }, [dispatch, errorCount]);

  // 各Questionを種別に応じて作成する
  const Questions = cxQuestions.map(
    (cxQuestion: any, cxQuestionIndex: number) => {
      const questionType = cxQuestion.questionType;

      switch (true) {
        case questionType === SELECT_SCORE:
          return (
            <Fragment key={cxQuestionIndex}>
              <SelectScore
                pageIndex={pageIndex}
                questionIndex={cxQuestionIndex}
                cxQuestion={cxQuestion}
              />
              <Box mx={4} mt={3}>
                <Divider />
              </Box>
            </Fragment>
          );
        case questionType === FREE_TEXT:
          return (
            <Fragment key={`${pageIndex}-${cxQuestionIndex}`}>
              <FreeText
                pageIndex={pageIndex}
                questionIndex={cxQuestionIndex}
                cxQuestion={cxQuestion}
                register={register}
                errors={errors}
              />
              <Box mb={3}></Box>
            </Fragment>
          );
        case questionType === DROPDOWN:
          return (
            <Fragment key={cxQuestionIndex}>
              <Dropdown
                pageIndex={pageIndex}
                questionIndex={cxQuestionIndex}
                cxQuestion={cxQuestion}
              />
              <Box mx={4} mt={3}>
                <Divider />
              </Box>
            </Fragment>
          );
        case questionType === RADIO_BUTTON:
          return (
            <Fragment key={cxQuestionIndex}>
              <RadioButton
                pageIndex={pageIndex}
                questionIndex={cxQuestionIndex}
                cxQuestion={cxQuestion}
              />
              <Box mx={4} mt={3}>
                <Divider />
              </Box>
            </Fragment>
          );
        case questionType === CHECKBOX:
          return (
            <Fragment key={cxQuestionIndex}>
              <CheckBox
                pageIndex={pageIndex}
                questionIndex={cxQuestionIndex}
                cxQuestion={cxQuestion}
              />
              <Box mx={4} mt={3}>
                <Divider />
              </Box>
            </Fragment>
          );
        case questionType === ZIPCODE:
          return (
            <Fragment key={cxQuestionIndex}>
              <Zipcode
                pageIndex={pageIndex}
                questionIndex={cxQuestionIndex}
                cxQuestion={cxQuestion}
              />
              <Box mb={3}></Box>
            </Fragment>
          );
        case questionType === CALENDAR:
          return (
            <Fragment key={cxQuestionIndex}>
              <Calendar
                control={control}
                pageIndex={pageIndex}
                questionIndex={cxQuestionIndex}
                cxQuestion={cxQuestion}
              />
              <Box mb={3}></Box>
            </Fragment>
          );
        default:
          return null;
      }
    }
  );

  return <>{Questions}</>;
};
